export default {"src":"/_next/static/media/Full-logo-on-blue-1568x617.9046dccf.svg","height":30,"width":120,"blurWidth":0,"blurHeight":0};